import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CHART_INK } from './agencyChartTheme';
import { InsightsCard } from './InsightsCard';

const useStyles = createUseStyles({
    body: {
        fontSize: 12.5,
        lineHeight: 1.5,
        color: CHART_INK.label
    }
});

/**
 * What the tab says instead of its figures when the organization could read none of its clients.
 *
 * Every figure on the page is a ratio over the clients that could be read, so over none of them
 * they stop being empty and start being wrong.
 */
export const NothingToChart: FC = () => {
    const classes = useStyles();

    return (
        <InsightsCard
            heading="Nothing to chart yet"
            blurb="The figures on this tab cover the clients this organization can read, and right now that is none of them."
        >
            <div className={classes.body} data-id="insights-nothing-to-chart">
                Once one of the clients above can be read, their findings appear here. Until then there is nothing
                to measure, and a chart drawn over no clients would say more than anybody knows.
            </div>
        </InsightsCard>
    );
};
